import { render, staticRenderFns } from "./PlanCartButton.vue?vue&type=template&id=71c00ec0"
import script from "./PlanCartButton.vue?vue&type=script&lang=js"
export * from "./PlanCartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports